import { apiClient } from './api-client';

export type VariableScope = 'GLOBAL' | 'FLOW' | 'PAGE';

export interface Variable {
  id: string;
  name: string;
  type: 'STRING' | 'NUMBER' | 'BOOLEAN';
  scope: VariableScope;
  defaultValue?: string;
  description?: string;
  tenantId: string;
  flowId?: string;
  pageNodeId?: string;
  elementId?: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export const variablesApi = {
  async getGlobalVariables() {
    const { data } = await apiClient.get<Variable[]>('/variables');
    return data;
  },

  async getFlowVariables(flowId: string) {
    const { data } = await apiClient.get<Variable[]>(`/variables/flow/${flowId}`);
    return data;
  },

  async createVariable(payload: {
    name: string;
    type?: 'STRING' | 'NUMBER' | 'BOOLEAN';
    scope: VariableScope;
    defaultValue?: string;
    description?: string;
    flowId?: string;
    pageNodeId?: string;
    elementId?: string;
  }) {
    const { data } = await apiClient.post<Variable>('/variables', payload);
    return data;
  },

  async updateVariable(id: string, payload: {
    name?: string;
    type?: 'STRING' | 'NUMBER' | 'BOOLEAN';
    defaultValue?: string;
    description?: string;
  }) {
    const { data } = await apiClient.put<Variable>(`/variables/${id}`, payload);
    return data;
  },

  async deleteVariable(id: string) {
    const { data } = await apiClient.delete(`/variables/${id}`);
    return data;
  },
};
